const getLastExtension = (fileName, search) => {
  if (!fileName) return null;
  return fileName.substr(fileName.lastIndexOf(search) + 1).toLowerCase();
};

export const getFileExtension = (filename) => getLastExtension(filename, '.');

export const MAX_BUNDLE_SIZE_IN_KB = 50;
export const MAX_FILE_SIZE = MAX_BUNDLE_SIZE_IN_KB * 1024;

export const EMAIL_SETTINGS_BUTTON_SMTP = "PLAIN"
export const EMAIL_SETTINGS_BUTTON_SMTPS = "SSL"
export const EMAIL_SETTINGS_BUTTON_SMTPTLS = "TLS"
export const EMAIL_SETTINGS_RADIO_SERVER = "SERVER"
export const EMAIL_SETTINGS_RADIO_MUTUAL = "MUTUAL"
export const SERVER_CERTIFICATE = "SERVER_CERTIFICATE"
export const CLIENT_CERTIFICATE = "CLIENT_CERTIFICATE"

export const convertFormDataToPayload = (formData) => {

  if (!formData?.enabled) {
    delete formData?.serverAuthCredentials;
    delete formData?.serverProperties;
  } else if (formData?.serverAuthCredentials?.username === "" && formData?.serverAuthCredentials?.password === "") {
    delete formData?.serverAuthCredentials;
  }

  if (formData?.serverProperties?.protocol === EMAIL_SETTINGS_BUTTON_SMTP) {
    delete formData?.serverProperties?.certificateName;
    delete formData?.serverProperties?.certificateContent;
    delete formData?.serverProperties?.clientCertUuid;
    delete formData?.serverProperties?.sslAuthType;
  }

  if (formData?.serverProperties?.sslAuthType === EMAIL_SETTINGS_RADIO_SERVER) {
    delete formData?.serverProperties?.clientCertUuid;
  }

  return removeEmptyKeysFromFormData(formData);
};

const removeEmptyKeysFromFormData = (formData) => {
  //  Below code will loop through the deep nested objects from formData and remove
  //  the keys if any are null or undefined or empty and returns the filtered formData
  //  with valid key values
  return Object.fromEntries(
    Object.entries(formData).map(([key, value]) => {
      if (typeof value === 'object' && value !== null) {
        return [key, removeEmptyKeysFromFormData(value)];
      }
      return [key, value];
    }).filter(([, value]) => value !== '' && (!(typeof value === 'object' && Object.keys(value).length === 0))),
  );
}

export const validateFormFields = (serverProperties, setFieldNameEmptyError,
  fieldName, fieldNameEmptyError) => {
  const isEmpty = serverProperties[fieldName] === "";
  setFieldNameEmptyError({ ...fieldNameEmptyError, [fieldName]: isEmpty });
};